/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

export default {
  order_note: {
    title: 'Order Notes Report',
    report_total: 'Report Total: {v}'
  }
}
